var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEigenlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.246094,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#1A0C6D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10871_16901)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5.24609,
    width: 14,
    height: 14,
    rx: 7,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7.24609,
    width: 8,
    height: 10,
    fill: "url(#pattern0_10871_16901)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10871_16901",
    x: 1,
    y: 1.24609,
    width: 22,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10871_16901"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10871_16901",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_10871_16901",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10871_16901",
    transform: "matrix(0.0173611 0 0 0.0138889 -0.0381944 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_10871_16901",
    width: 62,
    height: 72,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAABICAYAAACuukaYAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAPqADAAQAAAABAAAASAAAAABTsT+UAAADGElEQVR4Ae2bO28TQRDHZ+7h+PxQjJFI5DT5BHQ0fAcQPTUSEgKloKFzTYFAPGp6SvgaVNCDEFiJ4oCMcc723e6yC7JkrH2RnFaX1a508nln7mb+87vXrs846NxncN7G4O1o9vymbje7zYP9KCEfuE9H52eyIdIb36Yv36n9hsmgc/Ke26+qfQAindFnWxDuM12ZtkBcVhWf+wJxR3QTR3GMYZwlEuGSAIsPAf/cx6kkM/E80eVLS2KrvMuZ8FF+PBp0L12jbAtlKkhG8jSPn3DbHZm96j5nwgHekNEUxkoBvwD2Og9OGZz/QVIZY81Qq4sbFy09GtbyrWy1VsIrU2WxoyDcokheuQTiFwUnklj2DLCW/pDwL/Fah3TV4e1MGv+/OwnS/n7voHdasK3NjREXLCVZSqH8zm0nfCk2fVbfL5xwRHy1LMnTRHrjS5HGZYmE3lq02x+byyJdCd38vHDCuQDxWKtrrIzj6Xj8eKpz8vHiRlJGpcfDeiF8FL6uT7kehCtL46khEPcUrFJWIK4sjaeGQNxTsEpZgbiyNJ4aAnFPwSpl1Yx4JdPLfPYlNo7OnI3Hd+Bhu9Gab0eQSH8xYOliXlAskMEPjilXotIbBMiCICpnXlabOxMedZe3CcNnBIhcFEky/iPKo8ZsOqDbWbZK8CyfXyaHP03bORMOlGaA2OQJiUXa+LQS+Qyv5zCBudShwk5n5zhiZJgdrVCVxa6cCbfIxalLEO603DUIFojXAILTFAJxp+WuQbBAvAYQnKYQiDstdw2CBeI1gOA0hWqIo9XriDajMxufSgpU1Xi8tdO5eyUhaUOaVUJzYLTP+Bu8uoZA+3vde5ehjM48EYFQsK/57hHAsNTGquRfSH9fspnxQCplYrpJvKxjEiRmZxaa/XCTtokjeEZidv1o8uKTzrMq4uIlm54ukKVNFMZUHNOuGg1A4ylsdDBFqaHd6jrho3ArFkG4VZk8cgrEPYJpJSUQtyqTR06BuEcwraQE4lZl8sgpEPcIppUUH4mr5gT+KYgYj/O/s3rTBMjZkk/3mBT9Bls6ogL1WH7MAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEigenlayer);
export default __webpack_public_path__ + "static/media/eigenlayer.e4e8b0b4274c43b2f6062caefa1bab2a.svg";
export { ForwardRef as ReactComponent };